import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import PageTitle from "../../../components/Common/PageTitle"
import Spinners from "components/Common/Spinner"
import UserService from "Api/Services/UserService"
import DoctorSelector from "components/Common/DoctorSelector"
import {
  getStoredSelectedDoctorId,
  isGroupLoginUser,
  setStoredSelectedDoctorId,
} from "helpers/doctorSelection"

const AssignDrugList = () => {
  document.title = "Drug List | infuseone"

  const imageUrl = `${process.env.REACT_APP_DRUG_IMAGE_API_URL}`
  const [isLoading, setLoading] = useState(false)
  const [userDrugList, setUsersDruglist] = useState([])
  const [error, setError] = useState("")
  const [isListView, setIsListView] = useState(false)
  const [doctors, setDoctors] = useState([])
  const [selectedDoctorId, setSelectedDoctorId] = useState(getStoredSelectedDoctorId())
  const [groupLogin] = useState(isGroupLoginUser())
  const navigate = useNavigate()

  const loadUserAssignedDrugList = async doctorId => {
    setLoading(true)

    try {
      const response = await UserService.GetUserAssignedDrugList(doctorId).json()

      if (response.status === true) {
        setUsersDruglist(response.data || [])
        setError("")
        setLoading(false)
        return
      }

      setLoading(false)
      setUsersDruglist([])
      setError(response.message)
    } catch (error) {
      setLoading(false)
      setUsersDruglist([])
      setError("Something went wrong")
    }
  }

  const loadAccessibleDoctors = async () => {
    if (!groupLogin) {
      loadUserAssignedDrugList()
      return
    }

    try {
      const response = await UserService.GetAccessibleDoctors().json()

      if (!response.status) {
        setError(response.message || "Something went wrong")
        return
      }

      const availableDoctors = response.data || []
      const fallbackDoctorId = response.selected_doctor?.id ? String(response.selected_doctor.id) : ""
      const storedDoctorId = getStoredSelectedDoctorId()
      const nextDoctorId = availableDoctors.some(doctor => String(doctor.id) === storedDoctorId)
        ? storedDoctorId
        : fallbackDoctorId

      setDoctors(availableDoctors)
      setSelectedDoctorId(nextDoctorId)
      setStoredSelectedDoctorId(nextDoctorId)
      loadUserAssignedDrugList(nextDoctorId)
    } catch (error) {
      setError("Something went wrong")
    }
  }

  useEffect(() => {
    loadAccessibleDoctors()
  }, [])

  useEffect(() => {
    if (!groupLogin || !selectedDoctorId) {
      return
    }

    setStoredSelectedDoctorId(selectedDoctorId)
    loadUserAssignedDrugList(selectedDoctorId)
  }, [selectedDoctorId, groupLogin])

  const handleAssigneUDrugs = drugId => {
    navigate(`/assgined-user-drug-form/${drugId}`)
  }

  const toggleView = () => {
    setIsListView(!isListView)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="container-fluid">
            <PageTitle
              title="Drug List"
              actions={groupLogin ? (
                <DoctorSelector
                  doctors={doctors}
                  selectedDoctorId={selectedDoctorId}
                  onChange={setSelectedDoctorId}
                  compact
                />
              ) : null}
            />

            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              <Row className="mb-5">
                {error ? (
                  <div className="bg-white p-5 rounded">
                    <h5 className="text-center">{error}</h5>
                  </div>
                ) : null}

                <div className="d-flex justify-content-end mb-2">
                  <span className="badge btn btn-primary font-size-15 m-1">
                    <i
                      className="bx bx-list-ul font-size-20 mx-1"
                      onClick={toggleView}
                      style={{ cursor: "pointer", color: isListView ? "white" : "black" }}
                    ></i>
                    <i
                      className="bx bx-grid-alt font-size-20 mx-1"
                      onClick={toggleView}
                      style={{ cursor: "pointer", color: !isListView ? "white" : "black" }}
                    ></i>
                  </span>
                </div>

                {isListView ? (
                  <table className="table mt-3 commonboxform vertical-middle">
                    <thead>
                      <tr className="text-center">
                        <th>Image</th>
                        <th>Title</th>
                        <th>Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userDrugList.map((drugList, index) => (
                        <tr key={index} className="text-center">
                          <td>
                            <img className="imagedrugcls" src={`${imageUrl}/${drugList.image}`} alt={drugList.title} />
                          </td>
                          <td>
                            <Link to="#" className="text-dark">
                              {drugList.title}
                            </Link>
                          </td>
                          <td>
                            <a className="btn btn-secondary font-size-14 m-1" onClick={() => handleAssigneUDrugs(drugList.drug_id)}>
                              Fill Form
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  userDrugList.map((drugList, index) => (
                    <Col xl={3} sm={6} key={index}>
                      <Card className="text-center boxcardcls ">
                        <CardBody>
                          <div className="mb-3 imgwarp">
                            <img className="imagedrugcls" src={`${imageUrl}/${drugList.image}`} alt={drugList.title} />
                          </div>
                          <div>
                            <h5 className="font-size-15 mb-1">
                              <Link to="#" className="text-dark">
                                {drugList.title}
                              </Link>
                            </h5>
                            <div className="mt-2">
                              <a className="btn btn-secondary font-size-14 m-1" onClick={() => handleAssigneUDrugs(drugList.drug_id)}>
                                Fill Form
                              </a>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))
                )}
              </Row>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AssignDrugList
